import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'sc-category-selector',
	templateUrl: './category-selector.component.html',
	styleUrls: ['./category-selector.component.scss']
})
export class CategorySelectorComponent implements OnInit {
	public title: string;

	@Input() rowData: any;
	@Input() backToBranchIconSrc: string;
    @Input() backToBranchLabel: string;
	@Input() runAnimation: boolean = true;

	@Output() onClick: EventEmitter<any>;
	@Output() backToBranchClick: EventEmitter<any>;

	constructor() {
		this.title = 'Elegí la categoría';
		this.onClick = new EventEmitter();
        this.backToBranchClick = new EventEmitter();
	}

	ngOnInit() {
	}

	handleOnClick(event) {
		this.onClick.emit(event);
	}

	handleBackToBranchClick(event) {
        this.backToBranchClick.emit(event);
    }
}
